require('./bootstrap');
require('alpinejs');
require('./mobile-menu');
require('./sidemenu');
//require('./custom');
require('@fortawesome/fontawesome-pro/js/all');

import Vue from 'vue';
import dayjs from "dayjs";
import 'dayjs/locale/sk';
import summernote from 'summernote'

require('jquery-ui/ui/widget')
require('jquery-ui/ui/scroll-parent')
require('jquery-ui/ui/data')
require('jquery-ui/ui/widgets/mouse')
require('jquery-ui/ui/ie')
require('jquery-ui/ui/widgets/sortable')
require('select2')

const Swal = window.Swal = require('sweetalert2');


require('select2/dist/js/select2.full.min')
require('./jquery.print.min')

window.Sortable = require('sortablejs').Sortable;

window.cms = {
    mediaPickerCount: 0,
    mediaPickers    : {}
};


let relativeTime = require('dayjs/plugin/relativeTime');

dayjs.extend(relativeTime);

Vue.prototype.dayjs = dayjs;
Object.defineProperty(Vue.prototype, '$dayjs', {value: dayjs});
let linkPicker       = require('../components/LinkPicker').default;
let imagePicker      = require('../components/ImagePicker').default;
let multiImagePicker = require('../components/MultiImagePicker').default;
let vueComponents    = {};

vueComponents['linkPicker']       = Vue.component('link-picker', linkPicker);
vueComponents['imagePicker']      = Vue.component('image-picker', imagePicker);
vueComponents['multiImagePicker'] = Vue.component('multi-image-picker', multiImagePicker);

Vue.extend(linkPicker);
Vue.extend(imagePicker);
Vue.extend(multiImagePicker);

window.vueComponents = vueComponents;

var app = new Vue({
    el        : '#app',
    components: {
        linkPicker,
        imagePicker,
        multiImagePicker
    }
});

window.vueApp = app;


$(document).ready(function () {
    $('.select2').select2();
});

$('body').on('click', '.forceJsPrint', function (e) {
    e.preventDefault();
    $(this).doPrintPage(
        {
            attr   : 'href',
            message: 'Váš dokument sa pripravuje na tlač.'
        }
    );
});
